import {Component, Inject} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {StorageService} from './core/services/storage.service';
import {RETURN_URL} from './app.config';
import {environment} from '../environments/environment';
import {filter} from 'rxjs';

@Component({
    selector: 'ostso-root',
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'ostso.front';

    private readonly exceptionRoutes = ['/login', '/logout', '/', '/restore-password'] as const;

    constructor(private router: Router, private storage: StorageService, @Inject(RETURN_URL) private returnURL: string) {
        if (environment.production) return;
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                if (this.exceptionRoutes.some(e => e === this.router.url)) return;
                this.storage.setItem(this.returnURL, this.router.url);
            });
    }


}
